import React, { useEffect, useState } from "react";
import AddEditForm from "./ClientAddEditForm";
import { axios } from "../../../../Global";
import {
  setAppError,
  setPage,
  setBreadCrumb,
} from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ListDataClient from "./ListDataClient";
import PromptElement from "../../PromptElement";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { getClientData } from "../../../../store/Api";
import Breadcrumb from "../../../../utils/BreadCrumb";

export default function Client(props) {
  const navigate = useNavigate();
  const Client = useSelector((state) => state.clientData);
  const dispatch = useDispatch();

  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();

  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });

  const [clientList, setClientList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [clientId, setClientId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [authorizedPersonName, setAuthorizedPersonName] = useState("");
  const [headOfficeLocation, setHeadOfficeLocation] = useState("");
  const [companyRegistration, setCompanyRegistration] = useState("");
  const [laborLicenseNumber, setLaborLicenseNumber] = useState("");
  const [sponsorName, setSponsorName] = useState("");
  const [sponsorId, setSponsorId] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [authorizedPersonDesignation, setAuthorizedPersonDesignation] =
    useState("");
  const [authorizedPersonContact, setAuthorizedPersonContact] = useState("");
  const [authorizedPersonEmail, setAuthorizedPersonEmail] = useState("");
  const [
    authorizedProjectRepresentativeName,
    setAuthorizedProjectRepresentativeName,
  ] = useState("");
  const [
    authorizedProjectRepresentativeDesignation,
    setAuthorizedProjectRepresentativeDesignation,
  ] = useState("");
  const [
    authorizedProjectRepresentativeContact,
    setAuthorizedProjectRepresentativeContact,
  ] = useState("");
  const [
    authorizedProjectRepresentativeEmail,
    setAuthorizedProjectRepresentativeEmail,
  ] = useState("");
  const [
    authorizedAccountsRepresentativeName,
    setAuthorizedAccountsRepresentativeName,
  ] = useState("");
  const [
    authorizedAccountsRepresentativeDesignation,
    setAuthorizedAccountsRepresentativeDesignation,
  ] = useState("");
  const [
    authorizedAccountsRepresentativeContact,
    setAuthorizedAccountsRepresentativeContact,
  ] = useState("");
  const [
    authorizedAccountsRepresentativeEmail,
    setAuthorizedAccountsRepresentativeEmail,
  ] = useState("");
  const [beneficiaryBank, setBeneficiaryBank] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankBranch, setBankBranch] = useState("");
  const [bankType, setBankType] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [bankIban, setBankIban] = useState("");

  const [clientSpecific, setClientSpecific] = useState("");

  const [poBox, setPoBox] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [nationalIdentityNo, setNationalIdentityNo] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(getClientData(token));
  }, []);

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        name: name?.toUpperCase(),
        email: email?.toUpperCase(),
        mobile: mobile?.toUpperCase(),
        address: address?.toUpperCase(),
        head_office_location: headOfficeLocation?.toUpperCase(),
        company_registration: companyRegistration?.toUpperCase(),
        labor_license_number: laborLicenseNumber?.toUpperCase(),
        sponsor_name: sponsorName?.toUpperCase(),
        sponsor_id: sponsorId?.toUpperCase(),
        vat_number: vatNumber?.toUpperCase(),
        authorized_person_name: authorizedPersonName?.toUpperCase(),
        authorized_person_designation:
          authorizedPersonDesignation?.toUpperCase(),
        authorized_person_contact: authorizedPersonContact?.toUpperCase(),
        authorized_person_email: authorizedPersonEmail?.toUpperCase(),
        authorized_project_representative_name:
          authorizedProjectRepresentativeName?.toUpperCase(),
        authorized_project_representative_designation:
          authorizedProjectRepresentativeDesignation?.toUpperCase(),
        authorized_project_representative_contact:
          authorizedProjectRepresentativeContact?.toUpperCase(),
        authorized_project_representative_email:
          authorizedProjectRepresentativeEmail?.toUpperCase(),
        authorized_accounts_representative_name:
          authorizedAccountsRepresentativeName?.toUpperCase(),
        authorized_accounts_representative_designation:
          authorizedAccountsRepresentativeDesignation?.toUpperCase(),
        authorized_accounts_representative_contact:
          authorizedAccountsRepresentativeContact?.toUpperCase(),
        authorized_accounts_representative_email:
          authorizedAccountsRepresentativeEmail?.toUpperCase(),
        beneficiary_bank: beneficiaryBank?.toUpperCase(),
        bank_name: bankName?.toUpperCase(),
        bank_branch: bankBranch?.toUpperCase(),
        bank_type: bankType?.toUpperCase(),
        bank_account_number: bankAccountNumber?.toUpperCase(),
        bank_iban: bankIban?.toUpperCase(),
        client_specific: clientSpecific?.toUpperCase(),
        po_box: poBox?.toUpperCase(),
        pincode: pinCode?.toUpperCase(),
        national_identification_number: nationalIdentityNo?.toUpperCase(),
      };
      if (addOrEdit?.method === "add") {
        response = await axios.post(`/dashboard/client`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit?.method === "edit") {
        response = await axios.put(
          `/dashboard/client/${addOrEdit?.editId}`,
          body,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      const data = response?.data?.data;
      if (data) {
        dispatch(getClientData(token));
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "success",
          })
        );
        navigate("/dashboard/client");
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "client");
      setSubmitFormLoading(false);
      dispatch(setAppError({ msg: err.message }));
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/client");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id) => {
    navigate(`/dashboard/client/edit/${id}`);
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        const response = await axios.get(`/dashboard/client/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response.data.data;
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setClientId(data.clientID);
        setName(data.name);
        setEmail(data.email);
        setMobile(data.mobile);
        setAddress(data.address);
        setHeadOfficeLocation(data.head_office_location);
        setCompanyRegistration(data.company_registration);
        setLaborLicenseNumber(data.labor_license_number);
        setSponsorName(data.sponsor_name);
        setSponsorId(data.sponsor_id);
        setVatNumber(data.vat_number);
        setAuthorizedPersonName(data.authorized_person_name);
        setAuthorizedPersonDesignation(data.authorized_person_designation);
        setAuthorizedPersonContact(data.authorized_person_contact);
        setAuthorizedPersonEmail(data.authorized_person_email);
        setAuthorizedProjectRepresentativeName(
          data.authorized_project_representative_name
        );
        setAuthorizedProjectRepresentativeDesignation(
          data.authorized_project_representative_designation
        );
        setAuthorizedProjectRepresentativeContact(
          data.authorized_project_representative_contact
        );
        setAuthorizedProjectRepresentativeEmail(
          data.authorized_project_representative_email
        );
        setAuthorizedAccountsRepresentativeName(
          data.authorized_accounts_representative_name
        );
        setAuthorizedAccountsRepresentativeDesignation(
          data.authorized_accounts_representative_designation
        );
        setAuthorizedAccountsRepresentativeContact(
          data.authorized_accounts_representative_contact
        );
        setAuthorizedAccountsRepresentativeEmail(
          data.authorized_accounts_representative_email
        );
        setBeneficiaryBank(data.beneficiary_bank);
        setBankName(data.bank_name);
        setBankBranch(data.bank_branch);
        setBankType(data.bank_type);
        setBankAccountNumber(data.bank_account_number);
        setBankIban(data.bank_iban);
        setClientSpecific(data?.client_specific);
        setPoBox(data?.po_box);
        setPinCode(data?.pincode);
        setNationalIdentityNo(data?.national_identification_number);
      } catch (err) {
        dispatch(setAppError({ msg: err.message }));
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/client/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          dispatch(getClientData(token));
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
        setLoading((p) => ({ ...p, delete: false }));

        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setClientId("");
    setName("");
    setEmail("");
    setMobile("");
    setAddress("");
    setHeadOfficeLocation("");
    setCompanyRegistration("");
    setLaborLicenseNumber("");
    setSponsorName("");
    setSponsorId("");
    setVatNumber("");
    setAuthorizedPersonName("");
    setAuthorizedPersonDesignation("");
    setAuthorizedPersonContact("");
    setAuthorizedPersonEmail("");
    setAuthorizedProjectRepresentativeName("");
    setAuthorizedProjectRepresentativeDesignation("");
    setAuthorizedProjectRepresentativeContact("");
    setAuthorizedProjectRepresentativeEmail("");
    setAuthorizedAccountsRepresentativeName("");
    setAuthorizedAccountsRepresentativeDesignation("");
    setAuthorizedAccountsRepresentativeContact("");
    setAuthorizedAccountsRepresentativeEmail("");
    setBeneficiaryBank("");
    setBankName("");
    setBankBranch("");
    setBankType("");
    setBankAccountNumber("");
    setBankIban("");
    setClientSpecific("");
    setPoBox("");
    setPinCode("");
    setNationalIdentityNo("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);
  const isCreateMode = location.pathname.endsWith("/client/create");
  const isEditMode = location.pathname.includes("/client/edit");

  useEffect(() => {
    if ((isCreateMode || isEditMode) && !addOrEdit.method)
      navigate("/dashboard/client");
  }, []);

  const commonItems = [{ label: "CLIENT", link: "/dashboard/client" }];
  const breadcrumbItems = isEditMode
    ? [...commonItems, { label: "EDIT", link: "" }]
    : isCreateMode
      ? [...commonItems, { label: "CREATE", link: "/dashboard/client" }]
      : commonItems;

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems));
  }, [location.pathname]);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            {/* {checkAccess("Client", "client-create") && (
              <Link to="/dashboard/client/create">
                <button
                  className="p-2 bg-red text-white rounded-md"
                  onClick={addData}
                >
                  ADD NEW CLIENT +
                </button>
              </Link>
            )} */}

            {checkAccess("Client", "client-create") && (
              <ListDataClient
                list={Client}
                editData={editData}
                deleteData={setShowPromptElement}
                loading={loading}
                column={5}
                titles={[
                  "S.NO.",
                  "CLIENT ID",
                  "CLIENT NAME",
                  "COMPANY SPONSOR ID (700 SERIES)",
                  "AUTHORIZED PERSON NAME",
                  "CR NUMBER",
                  "ACTION",
                ]}
                addData={addData}
              />
            )}
            {!checkAccess("Client", "client-create") && (
              <ListDataClient
                list={Client}
                editData={editData}
                deleteData={setShowPromptElement}
                loading={loading}
                column={5}
                titles={[
                  "S.NO.",
                  "CLIENT ID",
                  "CLIENT NAME",
                  "COMPANY SPONSOR ID (700 SERIES)",
                  "AUTHORIZED PERSON NAME",
                  "CR NUMBER",
                  "ACTION",
                ]}
              />
            )}
          </>
        )}
        {addOrEdit.open && (
          <AddEditForm
            component="client"
            form={[
              {
                type: "text",
                text: "Client Name",
                name: "name",
                value: name,
                update: setName,
                columnName: "name",
              },
              {
                type: "email",
                text: "Client Email",
                name: "email",
                value: email,
                update: setEmail,
                columnName: "email",
              },
              {
                type: "tel",
                text: "Client Landline Number",
                name: "mobile",
                value: mobile,
                update: setMobile,
                columnName: "mobile",
              },
              {
                type: "textarea",
                text: "Client National Address",
                name: "address",
                value: address,
                update: setAddress,
                columnName: "address",
              },
              {
                type: "text",
                text: "Client PO Box",
                name: "po_box",
                value: poBox,
                update: setPoBox,
                columnName: "po_box",
              },
              {
                type: "text",
                text: "Client Pin Code",
                name: "pin_code",
                value: pinCode,
                update: setPinCode,
                columnName: "pin_code",
              },
              {
                type: "text",
                text: "Client BATAKA ID NO",
                name: "bataka_id_no",
                value: nationalIdentityNo,
                update: setNationalIdentityNo,
                columnName: "national_identity_no",
              },
              {
                type: "textarea",
                text: "Client Head Office Location",
                name: headOfficeLocation,
                value: headOfficeLocation,
                update: setHeadOfficeLocation,
                columnName: "head_office_location",
              },
              {
                type: "text",
                text: " Client CR Number",
                name: companyRegistration,
                value: companyRegistration,
                update: setCompanyRegistration,
                columnName: "company_registration",
              },
              {
                type: "text",
                text: "Client Labor Office File number (MOL)",
                name: laborLicenseNumber,
                value: laborLicenseNumber,
                update: setLaborLicenseNumber,
                columnName: "labor_license_number",
              },
              {
                type: "textarea",
                text: "Client Specific Instruction",
                name: clientSpecific,
                value: clientSpecific,
                update: setClientSpecific,
                columnName: "client_specific",
                notRequired: true,
              },
              {
                type: "text",
                text: "Client Sponsor ID (700 series)",
                name: sponsorId,
                value: sponsorId,
                update: setSponsorId,
                columnName: "sponsor_id",
              },
              {
                type: "text",
                text: " Client Vat Number",
                name: vatNumber,
                value: vatNumber,
                update: setVatNumber,
                columnName: "vat_number",
              },
              {
                type: "text",
                text: "Client Authorized Person Name",
                name: authorizedPersonName,
                value: authorizedPersonName,
                update: setAuthorizedPersonName,
                columnName: "authorized_person_name",
              },
              {
                type: "text",
                text: "Client Authorized Person Designation",
                name: authorizedPersonDesignation,
                value: authorizedPersonDesignation,
                update: setAuthorizedPersonDesignation,
                columnName: "authorized_person_designation",
              },
              {
                type: "text",
                text: "Client Authorized Person Contact",
                name: authorizedPersonContact,
                value: authorizedPersonContact,
                update: setAuthorizedPersonContact,
                columnName: "authorized_person_contact",
              },
              {
                type: "text",
                text: " Client Authorized Person Email",
                name: authorizedPersonEmail,
                value: authorizedPersonEmail,
                update: setAuthorizedPersonEmail,
                columnName: "authorized_person_email",
              },
              {
                type: "text",
                text: " Client Authorized Project Representative Name",
                name: authorizedProjectRepresentativeName,
                value: authorizedProjectRepresentativeName,
                update: setAuthorizedProjectRepresentativeName,
                columnName: "authorized_project_representative_name",
              },
              {
                type: "text",
                text: "Client Authorized Project Representative Designation",
                name: authorizedProjectRepresentativeDesignation,
                value: authorizedProjectRepresentativeDesignation,
                update: setAuthorizedProjectRepresentativeDesignation,
                columnName: "authorized_project_representative_designation",
              },
              {
                type: "text",
                text: " Client Authorized Project Representative Contact",
                name: authorizedProjectRepresentativeContact,
                value: authorizedProjectRepresentativeContact,
                update: setAuthorizedProjectRepresentativeContact,
                columnName: "authorized_project_representative_contact",
              },
              {
                type: "text",
                text: "Client Authorized Project Representative Email",
                name: authorizedProjectRepresentativeEmail,
                value: authorizedProjectRepresentativeEmail,
                update: setAuthorizedProjectRepresentativeEmail,
                columnName: "authorized_project_representative_email",
              },
              {
                type: "text",
                text: " Client Authorized Accounts Representative Name",
                name: authorizedAccountsRepresentativeName,
                value: authorizedAccountsRepresentativeName,
                update: setAuthorizedAccountsRepresentativeName,
                columnName: "authorized_accounts_representative_name",
              },
              {
                type: "text",
                text: " Client Authorized Accounts Representative Designation",
                name: authorizedAccountsRepresentativeDesignation,
                value: authorizedAccountsRepresentativeDesignation,
                update: setAuthorizedAccountsRepresentativeDesignation,
                columnName: "authorized_accounts_representative_designation",
              },
              {
                type: "text",
                text: " Client Authorized Accounts Representative Contact",
                name: authorizedAccountsRepresentativeContact,
                value: authorizedAccountsRepresentativeContact,
                update: setAuthorizedAccountsRepresentativeContact,
                columnName: "authorized_accounts_representative_contact",
              },
              {
                type: "text",
                text: " Client Authorized Accounts Representative Email",
                name: authorizedAccountsRepresentativeEmail,
                value: authorizedAccountsRepresentativeEmail,
                update: setAuthorizedAccountsRepresentativeEmail,
                columnName: "authorized_accounts_representative_email",
              },
              {
                type: "text",
                text: "Client Bank ACCOUNT NAME",
                name: beneficiaryBank,
                value: beneficiaryBank,
                update: setBeneficiaryBank,
                columnName: "beneficiary_bank",
              },
              {
                type: "text",
                text: "Client Bank Name",
                name: bankName,
                value: bankName,
                update: setBankName,
                columnName: "bank_name",
              },
              {
                type: "text",
                text: "Client Bank Branch",
                name: bankBranch,
                value: bankBranch,
                update: setBankBranch,
                columnName: "bank_branch",
              },
              {
                type: "text",
                text: "Client Bank Type",
                name: bankType,
                value: bankType,
                update: setBankType,
                columnName: "bank_type",
              },
              {
                type: "text",
                text: " Client Bank Account Number",
                name: bankAccountNumber,
                value: bankAccountNumber,
                update: setBankAccountNumber,
                columnName: "bank_account_number",
              },
              {
                type: "text",
                text: " Client Bank Iban",
                name: bankIban,
                value: bankIban,
                update: setBankIban,
                columnName: "bank_iban",
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={
              addOrEdit.method === "edit" && addOrEdit.loadedValues
                ? true
                : false
            }
          />
        )}
      </div>
    </>
  );
}
